import { sendQuotationChatMsg } from "./api/createQuotationChat";

export async function SSEChatClient(
  sourceEntity: string,
  userName: string,
  userEmail: string,
  chatSessionUid: string,
  inputValue: string,
  setMessage: (message: string, chatSessionUid: string) => void,
  setSSEDone: () => void,
) {
  let response: Response | null = null;
  try {
    response = await sendQuotationChatMsg({
      message: inputValue,
      chat_session_uid: chatSessionUid,
      source_entity: sourceEntity,
      username: userName,
      user_email: userEmail,
    });
  } catch {
    setSSEDone();
    return;
  }

  if (!response) {
    setSSEDone();
    return;
  }

  const reader = response.body?.getReader();
  if (!reader) {
    setSSEDone();
    return;
  }

  const decoder = new TextDecoder("utf-8");

  while (true) {
    try {
      const { value, done } = await reader.read();

      if (done) {
        setSSEDone();
        break;
      }

      const text = decoder.decode(value, { stream: true });
      const textArray = text.split("\n");
      for (const line of textArray) {
        if (line.trim() === "") continue;
        if (line.startsWith("data:") || line.startsWith("event:")) continue;
        try {
          const json = JSON.parse(line);
          setMessage(json.content, json.chat_session_uid);
        } catch {
          setSSEDone();
          break;
        }
      }
    } catch {
      setSSEDone();
      break;
    }
  }
}

